import React from 'react';
import { motion } from 'framer-motion';
export function FinalCTA() {
  return <section className="w-full bg-[#FDF8F4]/80 py-16 md:py-24" data-id="element-28">
      <motion.div className="max-w-3xl mx-auto px-6" initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.6
    }} data-id="element-29">
        <h2 className="font-lora text-3xl md:text-4xl font-bold text-charcoal mb-8 text-center" data-id="element-30">
          Tienes dos opciones
        </h2>

        <div className="font-inter text-lg text-charcoal/90 leading-relaxed space-y-6 mb-12" data-id="element-31">
          <p data-id="element-32">
            Cerrar esta página y seguir buscando una solución que "no sea tan
            simple". Seguir esperando que la ansiedad desaparezca sola. Seguir
            pagando con momentos de tu vida.
          </p>

          <p data-id="element-33">
            O hacer clic abajo, invertir menos de lo que cuesta un almuerzo, y
            tener el protocolo en tus manos en los próximos 3 minutos.
          </p>

          <p className="text-center text-xl font-semibold text-sage" data-id="element-34">
            Tu sistema nervioso ya sabe cómo calmarse. Solo necesita que tú le
            enseñes el interruptor.
          </p>
        </div>

        <motion.div className="text-center" whileHover={{
        scale: 1.02
      }} whileTap={{
        scale: 0.98
      }} data-id="element-35">
          <a href="#comprar" className="inline-block bg-sage text-white font-inter font-semibold px-12 py-6 rounded-lg hover:bg-sage/90 transition-colors duration-200 text-xl shadow-lg" data-id="element-36">
            👇 SÍ, QUIERO MI PROTOCOLO AHORA — $7.18
          </a>
        </motion.div>
      </motion.div>
    </section>;
}